export default __webpack_public_path__ + "static/image-64-6f9b757380991c493395f699e2ea42f3.jpg";